// extracted by mini-css-extract-plugin
module.exports = {"content":"DraggableStripe_content__3INAT","contentSelected":"DraggableStripe_contentSelected__2foCO","stripe":"DraggableStripe_stripe__1mnxT"};